/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Body_upload_photo_endpoint_api_v1_inspections__inspection_id__photos_post } from '../models/Body_upload_photo_endpoint_api_v1_inspections__inspection_id__photos_post';
import type { ReviewInspectionIssueRequest } from '../models/ReviewInspectionIssueRequest';
import type { ReviewRequest } from '../models/ReviewRequest';
import type { SaveRectificationRequest } from '../models/SaveRectificationRequest';
import type { SaveScoresRequest } from '../models/SaveScoresRequest';
import type { SubmitRectificationRequest } from '../models/SubmitRectificationRequest';
import type { SubmitScoresRequest } from '../models/SubmitScoresRequest';
import type { SuccessResponse_EmptyResp_ } from '../models/SuccessResponse_EmptyResp_';
import type { SuccessResponse_InspectionDetailResp_ } from '../models/SuccessResponse_InspectionDetailResp_';
import type { SuccessResponse_InspectionIssueResp_ } from '../models/SuccessResponse_InspectionIssueResp_';
import type { SuccessResponse_InspectionListResp_ } from '../models/SuccessResponse_InspectionListResp_';
import type { SuccessResponse_InspectionResp_ } from '../models/SuccessResponse_InspectionResp_';
import type { SuccessResponse_PhotoResp_ } from '../models/SuccessResponse_PhotoResp_';
import type { SuccessResponse_RectificationResp_ } from '../models/SuccessResponse_RectificationResp_';
import type { SuccessResponse_TemplateResp_ } from '../models/SuccessResponse_TemplateResp_';
import type { UpdateInspectionIssueRequest } from '../models/UpdateInspectionIssueRequest';
import type { VersionedRequest } from '../models/VersionedRequest';
import type { VoidRequest } from '../models/VoidRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class InspectionsService {
    /**
     * List Mine Endpoint
     * @returns SuccessResponse_InspectionListResp_ Successful Response
     * @throws ApiError
     */
    public static listMineEndpointApiV1InspectionsMineGet({
        period,
        status,
        limit = 50,
        cursor,
    }: {
        period?: (string | null),
        status?: (string | null),
        limit?: number,
        cursor?: (string | null),
    }): CancelablePromise<SuccessResponse_InspectionListResp_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/inspections/mine',
            query: {
                'period': period,
                'status': status,
                'limit': limit,
                'cursor': cursor,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Start Endpoint
     * @returns SuccessResponse_InspectionResp_ Successful Response
     * @throws ApiError
     */
    public static startEndpointApiV1InspectionsInspectionIdStartPost({
        inspectionId,
        requestBody,
    }: {
        inspectionId: number,
        requestBody: VersionedRequest,
    }): CancelablePromise<SuccessResponse_InspectionResp_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/inspections/{inspection_id}/start',
            path: {
                'inspection_id': inspectionId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Save Scores Endpoint
     * @returns SuccessResponse_InspectionResp_ Successful Response
     * @throws ApiError
     */
    public static saveScoresEndpointApiV1InspectionsInspectionIdScoresPatch({
        inspectionId,
        requestBody,
    }: {
        inspectionId: number,
        requestBody: SaveScoresRequest,
    }): CancelablePromise<SuccessResponse_InspectionResp_> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v1/inspections/{inspection_id}/scores',
            path: {
                'inspection_id': inspectionId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Submit Scores Endpoint
     * @returns SuccessResponse_InspectionResp_ Successful Response
     * @throws ApiError
     */
    public static submitScoresEndpointApiV1InspectionsInspectionIdSubmitScoresPost({
        inspectionId,
        requestBody,
    }: {
        inspectionId: number,
        requestBody: SubmitScoresRequest,
    }): CancelablePromise<SuccessResponse_InspectionResp_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/inspections/{inspection_id}/submit-scores',
            path: {
                'inspection_id': inspectionId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Review Endpoint
     * @returns SuccessResponse_InspectionResp_ Successful Response
     * @throws ApiError
     */
    public static reviewEndpointApiV1InspectionsInspectionIdReviewPost({
        inspectionId,
        requestBody,
    }: {
        inspectionId: number,
        requestBody: ReviewRequest,
    }): CancelablePromise<SuccessResponse_InspectionResp_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/inspections/{inspection_id}/review',
            path: {
                'inspection_id': inspectionId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * List Store Endpoint
     * @returns SuccessResponse_InspectionListResp_ Successful Response
     * @throws ApiError
     */
    public static listStoreEndpointApiV1InspectionsStoreGet({
        storeId,
        period,
        status,
        limit = 50,
        cursor,
    }: {
        storeId?: (number | null),
        period?: (string | null),
        status?: (string | null),
        limit?: number,
        cursor?: (string | null),
    }): CancelablePromise<SuccessResponse_InspectionListResp_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/inspections/store',
            query: {
                'store_id': storeId,
                'period': period,
                'status': status,
                'limit': limit,
                'cursor': cursor,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Save Rectification Endpoint
     * @returns SuccessResponse_RectificationResp_ Successful Response
     * @throws ApiError
     */
    public static saveRectificationEndpointApiV1InspectionsInspectionIdRectificationPatch({
        inspectionId,
        requestBody,
    }: {
        inspectionId: number,
        requestBody: SaveRectificationRequest,
    }): CancelablePromise<SuccessResponse_RectificationResp_> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v1/inspections/{inspection_id}/rectification',
            path: {
                'inspection_id': inspectionId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Submit Rectification Endpoint
     * @returns SuccessResponse_InspectionResp_ Successful Response
     * @throws ApiError
     */
    public static submitRectificationEndpointApiV1InspectionsInspectionIdSubmitRectificationPost({
        inspectionId,
        requestBody,
    }: {
        inspectionId: number,
        requestBody: SubmitRectificationRequest,
    }): CancelablePromise<SuccessResponse_InspectionResp_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/inspections/{inspection_id}/submit-rectification',
            path: {
                'inspection_id': inspectionId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Upload Photo Endpoint
     * @returns SuccessResponse_PhotoResp_ Successful Response
     * @throws ApiError
     */
    public static uploadPhotoEndpointApiV1InspectionsInspectionIdPhotosPost({
        inspectionId,
        formData,
    }: {
        inspectionId: number,
        formData: Body_upload_photo_endpoint_api_v1_inspections__inspection_id__photos_post,
    }): CancelablePromise<SuccessResponse_PhotoResp_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/inspections/{inspection_id}/photos',
            path: {
                'inspection_id': inspectionId,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Photo Content Endpoint
     * 取图代发 (raw bytes, 非 JSON; 鉴权 + RLS 校验后 FileResponse-style 返回)。
     *
     * 限流 (DISC-054): 按 actor + inspection 维度, 防鉴权后高频拉图打满 worker。
     * @returns any Successful Response
     * @throws ApiError
     */
    public static photoContentEndpointApiV1InspectionsInspectionIdPhotosPhotoIdContentGet({
        inspectionId,
        photoId,
    }: {
        inspectionId: number,
        photoId: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/inspections/{inspection_id}/photos/{photo_id}/content',
            path: {
                'inspection_id': inspectionId,
                'photo_id': photoId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete Photo Endpoint
     * @returns SuccessResponse_EmptyResp_ Successful Response
     * @throws ApiError
     */
    public static deletePhotoEndpointApiV1InspectionsInspectionIdPhotosPhotoIdDelete({
        inspectionId,
        photoId,
        requestBody,
    }: {
        inspectionId: number,
        photoId: number,
        requestBody: VersionedRequest,
    }): CancelablePromise<SuccessResponse_EmptyResp_> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/inspections/{inspection_id}/photos/{photo_id}',
            path: {
                'inspection_id': inspectionId,
                'photo_id': photoId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Overview Endpoint
     * @returns SuccessResponse_InspectionListResp_ Successful Response
     * @throws ApiError
     */
    public static overviewEndpointApiV1InspectionsOverviewGet({
        storeId,
        period,
        status,
        limit = 50,
        cursor,
    }: {
        storeId?: (number | null),
        period?: (string | null),
        status?: (string | null),
        limit?: number,
        cursor?: (string | null),
    }): CancelablePromise<SuccessResponse_InspectionListResp_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/inspections/overview',
            query: {
                'store_id': storeId,
                'period': period,
                'status': status,
                'limit': limit,
                'cursor': cursor,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Detail Endpoint
     * @returns SuccessResponse_InspectionDetailResp_ Successful Response
     * @throws ApiError
     */
    public static detailEndpointApiV1InspectionsInspectionIdGet({
        inspectionId,
    }: {
        inspectionId: number,
    }): CancelablePromise<SuccessResponse_InspectionDetailResp_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/inspections/{inspection_id}',
            path: {
                'inspection_id': inspectionId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Issue Endpoint
     * @returns SuccessResponse_InspectionIssueResp_ Successful Response
     * @throws ApiError
     */
    public static updateIssueEndpointApiV1InspectionsInspectionIdIssuesIssueIdPatch({
        inspectionId,
        issueId,
        requestBody,
    }: {
        inspectionId: number,
        issueId: number,
        requestBody: UpdateInspectionIssueRequest,
    }): CancelablePromise<SuccessResponse_InspectionIssueResp_> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v1/inspections/{inspection_id}/issues/{issue_id}',
            path: {
                'inspection_id': inspectionId,
                'issue_id': issueId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Review Issue Endpoint
     * @returns SuccessResponse_InspectionIssueResp_ Successful Response
     * @throws ApiError
     */
    public static reviewIssueEndpointApiV1InspectionsInspectionIdIssuesIssueIdReviewPost({
        inspectionId,
        issueId,
        requestBody,
    }: {
        inspectionId: number,
        issueId: number,
        requestBody: ReviewInspectionIssueRequest,
    }): CancelablePromise<SuccessResponse_InspectionIssueResp_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/inspections/{inspection_id}/issues/{issue_id}/review',
            path: {
                'inspection_id': inspectionId,
                'issue_id': issueId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Template Endpoint
     * @returns SuccessResponse_TemplateResp_ Successful Response
     * @throws ApiError
     */
    public static templateEndpointApiV1InspectionsInspectionIdTemplateGet({
        inspectionId,
    }: {
        inspectionId: number,
    }): CancelablePromise<SuccessResponse_TemplateResp_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/inspections/{inspection_id}/template',
            path: {
                'inspection_id': inspectionId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Void Endpoint
     * 作废仅超管 (service 层 is_super_admin 校验; require_role 放行普通角色但 service 拒)。
     * @returns SuccessResponse_InspectionResp_ Successful Response
     * @throws ApiError
     */
    public static voidEndpointApiV1InspectionsInspectionIdVoidPost({
        inspectionId,
        requestBody,
    }: {
        inspectionId: number,
        requestBody: VoidRequest,
    }): CancelablePromise<SuccessResponse_InspectionResp_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/inspections/{inspection_id}/void',
            path: {
                'inspection_id': inspectionId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
